import { render, staticRenderFns } from "./CreateCompositionForBarrel.vue?vue&type=template&id=284289e2"
import script from "./CreateCompositionForBarrel.vue?vue&type=script&lang=js"
export * from "./CreateCompositionForBarrel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports